/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Legend_CaveatInputs */



/**
* | output |
* | --- |
* | "Inherited cells show the everyone value only — team grants or floors a user inherits are not reflected, so effective access can differ." |
*
* @param {Rights_Tools_Legend_CaveatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_legend_caveat = /** @type {((inputs?: Rights_Tools_Legend_CaveatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Legend_CaveatInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geerbte Zellen zeigen nur den Wert für „Alle“ – Team-Gewährungen oder -Sperren, die ein Nutzer erbt, sind nicht berücksichtigt; der effektive Zugriff kann abweichen.")
	return /** @type {LocalizedString} */ ("Inherited cells show the everyone value only — team grants or floors a user inherits are not reflected, so effective access can differ.")
});